module.exports = __webpack_public_path__ + "images/icons/facilityPage/search.svg";